
export default function ContactHero() {
  return (
    <section className="relative min-h-[50vh] flex items-center justify-center overflow-hidden pt-20">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url("https://public.readdy.ai/ai/img_res/e6d488e81cab9eb1187f2970060bae41.jpg")'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-neutral-900"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 w-full text-center py-16 md:py-24">
        <nav className="flex items-center justify-center gap-2 text-sm text-neutral-400 mb-6">
          <a href="/" className="hover:text-white transition-colors cursor-pointer">Inicio</a>
          <i className="ri-arrow-right-s-line text-neutral-600"></i>
          <span className="text-amber-500">Contacto</span>
        </nav>

        <h1
          className="text-[48px] sm:text-[72px] md:text-[100px] lg:text-[120px] leading-none font-bold text-white mb-6"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '4px' }}
        >
          ENCUÉNTRANOS
        </h1>

        <p className="text-neutral-300 text-base md:text-lg max-w-2xl mx-auto">
          Visita nuestro estudio en Adra o escríbenos para cualquier consulta sobre tatuajes, arte urbano o colaboraciones
        </p>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-8">
          <div className="flex items-center gap-2 text-neutral-300 text-sm">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-map-pin-line text-amber-500"></i>
            </div>
            Adra, Almería
          </div>
          <div className="flex items-center gap-2 text-neutral-300 text-sm">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-time-line text-amber-500"></i>
            </div>
            Lun - Sáb: 10:00 - 20:00
          </div>
          <div className="flex items-center gap-2 text-neutral-300 text-sm">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-line text-amber-500"></i>
            </div>
            Con cita previa
          </div>
        </div>
      </div>
    </section>
  );
}
